import { styled, YStack } from "tamagui";
import { shadow } from "../../../themes/token-shadow";

// The white foreground card of the brand graphics, in the 160×160 design space.
// Callers place it with `top`, `left` and `rotate`.
export const FrontCard = styled(YStack, {
  position: "absolute",
  width: 120,
  height: 148,
  borderRadius: "$br3",
  borderWidth: "$border1",
  borderColor: "$borderDefault",
  backgroundColor: "$surface2",
  paddingHorizontal: "$sp1.5",
  paddingVertical: "$sp2.5",
  gap: "$sp1",
  alignItems: "center",
  ...shadow.heavy
});